import { render, staticRenderFns } from "./gaoxiao.vue?vue&type=template&id=23651058&scoped=true"
import script from "./gaoxiao.vue?vue&type=script&lang=js"
export * from "./gaoxiao.vue?vue&type=script&lang=js"
import style0 from "./gaoxiao.vue?vue&type=style&index=0&id=23651058&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23651058",
  null
  
)

export default component.exports